"use client";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { GoogleMap, Marker, StandaloneSearchBox } from "@react-google-maps/api";
import _ from "lodash";
import { geocodeByLatLng } from "react-google-places-autocomplete";
import Toast from "../../Hooks/useToast";
import { Button } from "../CustomComponents";
import { TRIP_STOP_IMAGES } from "../../Helper";
// import { info } from "@/utils/helper";

const Map = ({
  location,
  setLatLng = () => {},
  address = "",
  setAddress = () => {},
  option = {},
  zoom = 9,
  className = "",
  searchBar = false,
  isEdit = false,
  setClose = () => {},
}) => {
  const componentWillUnmount = useRef(false);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const [searchBox, setSearchBox] = useState(null);
  const [center, setCenter] = useState({ lat: 32.7767, lng: -97.030821 });
  const options = useMemo(
    () => ({
      mapId: "17c975ad78fa8aef",
      disableDefaultUI: true,
      clickableIcons: false,
      ...option,
    }),
    []
  );

  const [position, setPosition] = useState(location);
  const [add, setAdd] = useState(address);

  useEffect(() => {
    if (mapRef.current && !markerRef.current) {
      markerRef.current = new window.google.maps.marker.AdvancedMarkerElement({
        map: mapRef.current,
        position: center,
        title: "This is my marker",
      });
    }
  }, []);

  useEffect(() => {
    if (!location || (!location.lat && !location.lng)) {
      getCurrentLocation();
    }

    return () => {
      componentWillUnmount.current = true;
    };
  }, []);

  useEffect(() => {
    (async () => {
      if (
        !mapRef.current ||
        _.isEmpty(position) ||
        position.lat == null || // Ensures lat is neither null nor undefined
        position.lng == null
      ) {
        return;
      }

      await mapRef.current.panTo({ lat: position.lat, lng: position.lng });
      // mapRef.current?.setZoom(14);
    })();

    return () => {
      if (componentWillUnmount.current) {
        if (position.lat == null && position.lng == null) {
          setLatLng({
            lat: position.lat,
            lng: position.lng,
          });
          setAddress(add);
        }
      }
    };
  }, [position]);

  useEffect(() => {
    if (mapRef.current && position.lat != null && position.lng != null) {
      if (markerRef.current) {
        markerRef.current.map = null;
      }

      markerRef.current = new window.google.maps.marker.AdvancedMarkerElement({
        map: mapRef.current,
        position: { lat: position.lat, lng: position.lng },
        title: "Selected Location",
        content: (() => {
          const img = document.createElement("img");
          img.src = TRIP_STOP_IMAGES["home"];
          img.style.width = "50px";
          img.style.height = "50px";
          return img;
        })(),
      });
    }
  }, [position]);

  const getCurrentLocation = useCallback(() => {
    navigator.geolocation.getCurrentPosition(
      async function (position) {
        const { latitude, longitude } = position.coords;
        try {
          const places = await geocodeByLatLng({
            lat: latitude,
            lng: longitude,
          });
          if (_.isEmpty(places)) {
            Toast("Unable to find address for this location");
          }
          setAdd(places[0].formatted_address);
          setPosition({
            lat: latitude,
            lng: longitude,
          });
          await mapRef?.current?.panTo({ lat: latitude, lng: longitude });
        } catch (err) {
          console.log(err);
          Toast("Unable to find address for this location");
        }
      },
      function () {
        Toast("Site Not Able To Access Your location !");
      }
    );
  }, []);

  const onLoad = useCallback((map) => {
    mapRef.current = map;
    if (location) {
      mapRef.current.setZoom(14);
    }
  }, []);

  const onClick = async (e) => {
    if (!isEdit || !e.latLng) return;

    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    try {
      const places = await geocodeByLatLng({ lat, lng });
      if (_.isEmpty(places)) {
        Toast("Unable to find address for this location");
      }

      setPosition({ lat, lng });
      setAdd(places[0].formatted_address);
    } catch (err) {
      console.log(err);
      Toast("Unable to find address for this location");
    }
  };

  const handleLoad = (ref) => {
    setSearchBox(ref);
  };

  const handlePlaceChange = async () => {
    if (!searchBox) return;
    const places = searchBox.getPlaces();
    if (!places || places.length === 0) return;

    const place = places[0];
    const { lat, lng } = place.geometry.location; // Fixed Type Assertion
    setAdd(place?.formatted_address ?? "");
    setPosition({
      lat: lat(),
      lng: lng(),
    });
  };

  const handleAddressChange = (e) => {
    setAdd(e.target.value);
    if (position.lat != null && position.lng != null) {
      setCenter({ lat: position.lat, lng: position.lng });
      setPosition({});
    }
  };

  const saveLocation = () => {
    if (position.lat != null && position.lng != null) {
      setLatLng({ lat: position.lat, lng: position.lng });
      setAddress(add);
    }
    setClose(false);
  };

  return (
    <div className="w-100 h-100 d-flex flex-column">
      <GoogleMap
        zoom={zoom}
        center={
          position.lat != null && position.lng != null
            ? { lat: position.lat, lng: position.lng }
            : center
        }
        mapContainerClassName={`googleMap ${className}`}
        options={options}
        onLoad={onLoad}
        onClick={onClick}
      >
        {/* {position.lat != null && position.lng != null && (
          // <Marker position={{ lat: position.lat, lng: position.lng }} />
          <Marker
            position={{ lat: position.lat, lng: position.lng }}
            icon={{
              url: TRIP_STOP_IMAGES["home"],
              scaledSize: new window.google.maps.Size(40, 40),
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(20, 40),
            }}
          />
        )} */}

        {!searchBar ? (
          ""
        ) : (
          <StandaloneSearchBox
            onPlacesChanged={handlePlaceChange}
            onLoad={handleLoad}
          >
            <input
              type="text"
              placeholder="Search your address here"
              value={add}
              onChange={handleAddressChange}
              style={{
                boxSizing: "border-box",
                border: `1px solid transparent`,
                width: `70%`,
                maxWidth: `600px`,
                height: `45px`,
                padding: `0 12px`,
                borderRadius: `3px`,
                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                fontSize: `14px`,
                outline: `none`,
                margin: "auto",
                textOverflow: `ellipses`,
                position: "absolute",
                top: "60px",
                left: "50%",
                right: "50%",
                transform: "translate(-50%,-50%)",
              }}
            />
          </StandaloneSearchBox>
        )}
      </GoogleMap>
      <Button
        classes="px-4 mt-1 royalBlueBg"
        text="Save"
        onClick={saveLocation}
      />
    </div>
  );
};

export default React.memo(Map);
